import { useCallback } from "react";

import * as MutationRepository from "../repository/mutation";

import type * as DiscountItemMultiShared from "../../../_shared";

type Props = {
	inputModel: DiscountItemMultiShared.Model.ModelType.DiscountMultiFormModel["InputModel"];
	onResetViewModel: () => void;
};

export const useUpdateDiscountMulti = ({ inputModel, onResetViewModel }: Props) => {
	const { onUpdateDiscountMulti: _onUpdateDiscountMulti } = MutationRepository.useDiscountMultiUpdateMutation({
		onResetViewModel,
	});

	const onUpdateDiscountMulti = useCallback(() => {
		_onUpdateDiscountMulti(inputModel);
	}, [_onUpdateDiscountMulti, inputModel]);

	return {
		onUpdateDiscountMulti,
	};
};
